import { render } from "./ClustersPage.vue?vue&type=template&id=5a0c72c3&ts=true"
import script from "./ClustersPage.vue?vue&type=script&lang=ts"
export * from "./ClustersPage.vue?vue&type=script&lang=ts"

import "./ClustersPage.vue?vue&type=style&index=0&id=5a0c72c3&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__